import './app.scss';
import './index.scss';
import './assets/iconmoon/icon/style.css';
import './app.css'
import 'bootstrap-icons/font/bootstrap-icons.css'; // For Bootstrap Icons
import Navbar from './Components/MenuLayout/Navbar/Navbar';
import SideBar from './Components/MenuLayout/SideBar';
import Footer from './Components/MenuLayout/Footer';
import MainContent from './Components/MenuLayout/MainContent';
import { useCallback, useEffect, useRef, useState } from 'react';
import React from 'react';
import Cookies from "js-cookie";
import CacheBuster from 'react-cache-buster';
import packageJson from '../package.json'
import useHandleSwitchPractice from './customhooks/useHandleSwitchPractice';
import useLoadAppData from './utils/useLoadAppData';
import { isChildWindow } from './utils/Constants';
import ContentReceiver from './Components/MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver';
import UserActivityChecker from './Components/shared/UserActivityChecker/UserActivityChecker'
import { useSelector } from 'react-redux';
import TopSideBar from './Components/MenuLayout/TopSideBar';
import useOpenTab from './Components/MenuLayout/Navbar/NavbarComponents/GlobalInstantSearch/useOpenTab';
import ShortcutKeysWrapper from './Components/General/ShortcutKeysWrapper/ShortcutKeysWrapper';
import ChildCustomScreenView from './Components/Utilities/ChildCustomScreenView/ChildCustomScreenView';
import UpdateNotification from './shared-components/UpdateNotification';


function App() {
  const isProduction = process.env.NODE_ENV === 'production';

  if (process.env.NODE_ENV === "production") {
    // For production only
    console.log = () => { };
    console.warn = () => { };
    console.error = () => { };
    console.info = () => { };
    console.debug = () => { };
  }
  useLoadAppData();
  useHandleSwitchPractice();
  let token = useSelector(state => state?.Login?.payload?.token);
  let childCustomView = useSelector(state => state?.ChildCustomViewReducer);

  // Custom hook "useOpenTab" returns states and functions required to open Components
  const [openTab, setOpenTab] = useState('');

  // Login.payload.token // Default Value null
  // Login.token // correct


  //////////////////////////////////////////

  // const handleLoadDDForAgency = () => {
  //   setisLoading(true)
  //   ServerRequestProtected(API_URL_Agecny + "/FillDropDownAgency", 'post', {
  //   }).then((response) => {
  //     setisLoading(false)
  //     dispatch(GeneralDropDowns(response))
  //     // dispatch(PracticeID(response.Practice[0]?.PracticeID))
  //     // setPracticeName(response.Practice[0]?.PracticeName)
  //   }).catch((error) => {
  //     setisLoading(false)
  //     NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
  //   })
  // }

  useEffect(() => {
    const timer = setTimeout(() => {
      // document.documentElement.style.setProperty('--orangeBright', '#FFB01F');
      // document.documentElement.style.setProperty('--orangeBright-rgb', '255, 176, 31');
      // document.documentElement.style.setProperty('--orange', '#f5a524');
      // document.documentElement.style.setProperty('--primary', '#0046BB');
      // document.documentElement.style.setProperty('--BlueColor', '#0FC3D1');
      // document.documentElement.style.setProperty('--BlueLight', '#F7FAFC');
      // document.documentElement.style.setProperty('--font-r', 'Inter');
      // document.documentElement.style.setProperty('--font-sb', 'Inter');
      // document.documentElement.style.setProperty('--font-b', 'Inter');
      // document.documentElement.style.setProperty('--font-B', 'Inter');
    }, 5000);

    var getScreenWidth = window.innerWidth
    if (getScreenWidth > 992) {
      document.body.classList.add("desktop")
    }
    ////==== Collapse sidebar in case of sub browser tab ====////
    console.log("browserNewTabContent", Cookies.get('browserNewTabContent'))
    if (isChildWindow) {
      document.body.classList.add("desktop", "sidebar-slim")
    }
    if (getScreenWidth > 600 && getScreenWidth < 992) {
      document.body.classList.add("tablet", "sidebar-slim")
    }
    if (getScreenWidth < 600) {
      document.body.classList.add("mobile")
    }
    window.addEventListener("resize", () => {
      var getScreenWidth = window.innerWidth

      if (getScreenWidth > 992) {
        document.body.classList.remove("mobile", "tablet", "sidebar-slim", "sidebar-mobile")
        document.body.classList.add("desktop")
      }
      if (getScreenWidth > 600 && getScreenWidth < 992) {
        document.body.classList.remove("mobile", "desktop", "mobile", "sidebar-mobile-open")
        document.body.classList.add("tablet", "sidebar-slim")
      }
      if (getScreenWidth < 600) {
        document.body.classList.remove("tablet", "desktop", "sidebar-slim")
        document.body.classList.add("mobile")
      }
    }, false);
    return () => clearTimeout(timer);
  }, []);
  ///////////////////
  // const isLive = process.env.REACT_APP_ISLIVE
  // useEffect(() => {
  //   if (isLive === 'true') {
  //     // Disable right-click context menu
  //     const disableRightClick = (e) => {
  //       e.preventDefault();
  //     };

  //     document.addEventListener('contextmenu', disableRightClick);

  //     // Clean up the event listener on unmount
  //     return () => {
  //       document.removeEventListener('contextmenu', disableRightClick);
  //     }
  //   };
  // }, []);

  const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");

  const isTobNav = ThemeConfiguration?.configuration?.navigation?.type === 'TopBar'; 

  return (
    <>
      {token === null ? // incase someone accessing app for the first time with 'pms' route
        <></> :
        <CacheBuster
          currentVersion={packageJson.version} 
          isEnabled={isProduction} //If false, the library is disabled.
          isVerboseMode={false} //If true, the library writes verbose logs to console.
        // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
        // metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
        >
          {/* <UpdateNotification /> */}
          <ShortcutKeysWrapper>
            <div className={`layout row g-0 ${isTobNav ? "ar_overall-theme-changes" : ""}`}>
              {/* {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : <></>} */}
              <ContentReceiver />
              <UserActivityChecker />
              {!isChildWindow &&
                <div className="layout d-block m-0 h-auto">
                  <div className="app-container rounded-0 overflow-visible">
                    {isTobNav ? <Navbar /> : null}
                  </div>
                </div>
              }

              {isTobNav ? <TopSideBar /> : <SideBar />}
              <div className={`app-container px-0 ${isChildWindow ? 'col-lg-12 col-md-12  rounded-0 w-100 ms-0' : 'col-md-9 col-lg-10'}`}>
                {isTobNav ? null : <Navbar />}
                {isChildWindow && isTobNav ? <Navbar /> : null}
                <div className='app-content'>
                  {(isChildWindow && childCustomView?.name === "ChildCustomView") ? <ChildCustomScreenView dataProp={childCustomView} /> : <><MainContent /></>}
                  {/* <div className={activeTab === 0 ? 'app-content' : 'app-content-h'}>
              <BillingTabContent />
            </div> */}
                </div>
                <Footer />
              </div>
            </div>
          </ShortcutKeysWrapper>
        </CacheBuster>}
    </>
  );
}

export default App;